<template>
  <div class="page">
    <top-header></top-header>
    <b-container fluid style="margin-top:5% !important">
      <b-row class="mt-3 mb-2">
        <b-col class="col-md-6 col-sm-6 col-xs-6">
          <h3>Dashboard Live Reports At Time</h3>
        </b-col>
        <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
          
          <!-- <b-button variant="dark" pill  size="sm" class="mr-2" @click="downloadPDF()">Download PDF</b-button> -->
					<b-button variant="dark" pill size="sm" @click="downloadcsv()">Download CSV</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col class="col-md-12 col-sm-12 col-xs-12">
          <div class="container-box">
            <b-row class="mt-4 px-3">
              <b-col>
                <b-form inline>
                  <b-form-group>
                    <!-- <b-calendar v-model="datefrom" ></b-calendar> -->
                    <label for="inline-form-input-name" class="mr-sm-2 justify-left">From: </label>
                 
                    <b-form-datepicker
                      v-model="datefrom"
                      class="mr-sm-2"
                      size="sm"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    ></b-form-datepicker>
                    
                  </b-form-group>
                  <b-form-group class="mt-4">
                    <b-form-input id="type-ontime" type="time" size="sm" required v-model="datefrom_time" ></b-form-input> 
                  </b-form-group>
                



                  <b-form-group class="ml-5">
                    <label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
                    <b-form-datepicker
                      v-model="dateto"
                      class="mr-sm-2"
                      size="sm"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    ></b-form-datepicker>
                   
                  </b-form-group>
                  <b-form-group class="mt-4">
                    <b-form-input 
                    id="type-ontime" 
                    type="time" 
                    size="sm" 
                    required 
                    v-model="dateto_time" ></b-form-input>

                  </b-form-group>
                  
                  <b-button @click="fetchDailyConsumption()" size="sm" class="mt-4 ml-4">Show</b-button>
                  
                </b-form>
              </b-col>
            </b-row>
            
            <b-row class="mt-4 px-3" v-if="records.length > 0">
              <b-col lg="3">
                <span class="mr-2">Show</span>
                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                </b-form-select>
                <span class="ml-2">entries</span>
              </b-col>
              <b-col lg="6"> </b-col>
              <b-col lg="3">
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                    </b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="px-3 pt-3" v-if="records.length>0">
              <b-col lg="12">
                <b-table id="my-table" responsive show-empty sticky-header small striped outlined head-variant="dark" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" >
									<!-- <template v-slot:cell(ccms_on)="row">
                   
                   <b-link :href="'/dashboard-report-details/'+row.item.id">{{row.value}}</b-link>
									</template> -->
									<!--<template v-slot:cell(supply)="row">
										<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template> -->
                  <!-- <template v-slot:cell(actions)="row">
                    <b-button variant="primary" pill size="sm" :href="'/dashboard-report-details/'+row.item.id">Details</b-button>
                  </template> -->
								</b-table>


                <!-- <b-table
                  show-empty
                  small
                  striped
                  responsive
                  outlined
                  id="my-table"
                  sticky-header="true"
                  :items="records"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filterIncludedFields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template #head()="scope">
                    <div class="text-nowrap">
                      {{ scope.label }}
                    </div>
                  </template>
                  <template v-slot:cell(ulb_id)="row">
                    <b-label>{{ getUlbLabel(row.value)[0].title }}</b-label>
                  </template>
                  <template v-slot:cell(status)="row">
                    <b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
                    <b-badge pill variant="success" v-else>ACTIVE</b-badge>
                  </template>
                </b-table> -->
              </b-col>
            </b-row>
            <b-row class="px-3" v-if="records.length > 0">
              <b-col lg="6">
                <span class="mr-2"
                  >Showing {{ currentPage }} to {{ perPage > records.length ? records.length : perPage }} of
                  {{ records.length }} entries</span
                >
              </b-col>
              <b-col lg="3" offset-md="3">
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  prev-text="Prev"
                  next-text="Next"
                  first-number
                  last-number
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <transition name="fade">
      <b-row
        v-if="loading"
        class="loading"
        style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);"
        align-v="center"
        align-h="center"
      >
        <b-spinner label="Busy" variant="light"></b-spinner>
      </b-row>
    </transition>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "DashboardReport",
  components: {
    "top-header": Header,
  },
  mounted() {
    var self = this;
    Object.assign(self.selectedItem, self.emptyItem);
    //this.loadzones();
    //this.initload();
  },
  data() {
    var self = this;
    return {
      loading: false,
      email: "",
      password: "",

      recordUrl: self.$session.get("apiurl") + "aligarhapi/zones",
      consumptionUrl: self.$session.get("apiurl") + "aligarhapi/dashboard-live-report",
      //updateUrl: self.$session.get("apiurl") + "aligarhapi/zone-edit",
      //deleteUrl: self.$session.get("apiurl") + "aligarhapi/zone-remove",
     
      datefrom: self
        .$moment()
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
      dateto: self
        .$moment()
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
      datefrom_time:'00:00',
      dateto_time:'00:00',
      zones: [],
      records: [],
      statusOptions: [
        { value: 0, text: "Disabled" },
        { value: 1, text: "Enabled" },
      ],
      ulb_options: [],
      fields: [
        { key: "feeder_pillar_no", label: "FP no.", class: "text-center" },
       /*  { key: "imei_no", label: "imei_no", class: "text-center" }, */
        { key: "location_lat", label: "Latitude ", class: "text-center" },
        { key: "location_lng", label: "Longitude", class: "text-center" },        
        { key: "zone_id", label: "zone_id",class: "text-center"},
        { key: "location", label: "Location",class: "text-left" },
        { key: "Physical_Load", label: "Total Load (KW)",class: "text-center",
        formatter: (value) => { 					
						return parseFloat(value/1000).toFixed(2);
					}, },
        { key: "actual_load", label: "Current Load (KW)",class: "text-center",
        formatter: (value) => { 					
						return parseFloat(value).toFixed(2);
					}, },      
        { key: "total_fittings", label: "Total Lights",class: "text-center" },
        { key: "light_on", label: "Total Light ON",class: "text-center" },
        { key: "light_off", label: "Total Light OFF" ,class: "text-center"},
        { key: "diffrent", label: "Load Diffrence" ,class: "text-center", sortable: true, 'extra': 1,
            formatter: (value,key,item) => { 	
                var pl = (item.Physical_Load/1000);
                var al = item.actual_load;
              return (pl - al).toFixed(2);
              
            }
        },
        { key: "LoadStatus", label: "Load Status" ,class: "text-center", sortable: true,   'extra': 1,
           formatter: (value,key,item) => { 	
              var pl = (item.Physical_Load/1000);
              var al = item.actual_load;
              if(al>pl){
                return "Overload"
              }else{
                return "Underload";
              }						
					  }
        },
       
        { key: "update_time", label: "Update Time",class: "text-center"},
       
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: {},
      emptyItem: {
        id: 0,
        ulb_id: "",
        title: "",
        areacode: "",
        status: 0,
      },
    };
  },
  methods: {
    getUlbLabel: function(value) {
      return this.zones.filter(function(item) {
        return item.id == value;
      });
    },
    filterULB: function(items) {
      var self = this;
      return items.filter(function(item) {
        return item.state == self.selectedItem.state;
      });
    },
    async fetchDailyConsumption() {
      var self = this;
      self.loading = true;
      var fromdate = self.datefrom + ' ' + self.datefrom_time;
      var todate = self.dateto + ' ' + self.dateto_time;
      //console.log("fromdate::", fromdate, "todate::", todate);

      // ✅ Convert to moment objects
      var start = self.$moment(fromdate, "YYYY-MM-DD HH:mm");
      var end = self.$moment(todate, "YYYY-MM-DD HH:mm");
      // ✅ Check valid
      if (!start.isValid() || !end.isValid()) {
        alert("Invalid date format");
        return;
      }
      // ✅ Get difference in minutes
      var diffMinutes = end.diff(start, 'minutes');
     // console.log("diffMinutes::", diffMinutes);
      // ❌ alert('diffMinutes', diffMinutes);  <-- wrong usage
      //alert("Difference: " + diffMinutes + " minutes");

      // ✅ Condition check
      if (diffMinutes <=0 || diffMinutes > 20) {
        
        self.$bvToast.toast("Invalid time range (must be within 20 minutes)", {
          title: 'Status',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 5000,
          variant: 'warning',
          solid: true,
          appendToast: true
        });
        self.records =[];
        self.totalRows = 0; 
        self.loading = false;
        return false;
      }else{
        await self.axios
          .post(this.consumptionUrl, {
            accesskey: self.$session.get("access_key"),
            //ulb: self.selectedItem.ulb,
            /* datefrom: self.datefrom,
            dateto: self.dateto, */
            datefrom: self.datefrom+' '+self.datefrom_time,
            dateto: self.dateto+' '+self.dateto_time,
          })
          .then(function(response) {
            if (response.data.error == 0 || response.data.error == "0") {
              self.records =[];
              self.records = response.data.result.devices;
              self.totalRows = self.records.length;          
              self.$bvToast.toast(response.data.message, {
                title: 'Status',
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: 5000,
                variant: 'warning',
                solid: true,
                appendToast: true
              });
              self.loading = false;
            }

          
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
    showAddModal() {
      this.selectedItem = Object.assign({}, this.emptyItem);
      this.$root.$emit("bv::show::modal", "my-model");
    },
    showUpdateModal(item, index, button) {
      var self = this;
      this.selectedItem = Object.assign({}, item);

      var zoneinfo = self.zones.filter(function(zone) {
        console.log(item.ulb_id + " " + zone.id);
        if (item.ulb_id == zone.id) {
          return zone;
        }
      });

      this.selectedItem.state_id = zoneinfo[0].state;
      this.$root.$emit("bv::show::modal", "my-model", button);
    },
    showDeleteModal(item) {
      var self = this;
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete Zone or ULB.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            self.axios
              .post(self.deleteUrl, {
                accesskey: self.$session.get("access_key"),
                deleteid: item.id,
              })
              .then(function(response) {
                if (response.data.error == 0 || response.data.error == "0") {
                  self.$bvToast.toast(response.data.message, {
                    title: "Delete",
                    toaster: "b-toaster-bottom-right",
                    autoHideDelay: 5000,
                    variant: "warning",
                    solid: true,
                    appendToast: true,
                  });
                  //self.initload();
                }
              })
              .catch(function(error) {
                alert(error);
              });
          } else {
            //alert('no '+item.id);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    modalSubmit(bvModalEvt) {
      var self = this;
      self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = "";
      if (self.selectedItem.id == 0) {
        submitUrl = self.insertUrl;
      } else {
        submitUrl = self.updateUrl;
      }

      self.axios
        .post(submitUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvModal.hide("my-model");
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
            //self.initload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },
    initload() {
      var self = this;

      self.axios
        .post(self.recordUrl, {
          accesskey: self.$session.get("access_key"),
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            //var filteredarr = self.filtercategory(response.data.result);

            self.records = response.data.result;
            self.loading = false;
            self.totalRows = self.records.length;

           
          }
        })
        .catch(function(error) {
          alert(error);
        });
      //alert('login '+self.email+" "+self.password);
    },
    /*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadcsv() {
  var self = this;

  var d = new Date();
  var uniq =
    d.getFullYear() +
    "-" +
    (d.getMonth() + 1) +
    "-" +
    d.getDate() +
    "-" +
    d.getTime();

  var header = [];
  var finalarr = [];

  // 👉 Create Header
  self.fields.forEach(function (item) {
    header.push(item.label);
  });

  finalarr.push(header);

  // 👉 Loop records (use paginatedRecords if needed)
  var dataSource = self.records; 
  // If you want only visible page:
  // var dataSource = self.paginatedRecords;

  dataSource.forEach(function (row) {
    var dataarr = [];

    self.fields.forEach(function (field) {
      var value = row[field.key];

      // ✅ Apply same formatter as UI
      if (field.formatter) {
        try {
          value = field.formatter(row[field.key], field.key, row);
        } catch (e) {
          value = row[field.key];
        }
      }

      // ✅ Handle null/undefined
      if (value === null || value === undefined) {
        value = "";
      }

      // ✅ Remove commas (to avoid CSV breaking)
      if (typeof value === "string") {
        value = value.replace(/,/g, " ");
      }

      dataarr.push(value);
    });

    finalarr.push(dataarr);
  });

  // 👉 Convert to CSV
  let csvContent =
    "data:text/csv;charset=utf-8," +
    finalarr.map((e) => e.join(",")).join("\n");

  var encodedUri = encodeURI(csvContent);

  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "REPORT_DASHBOARD_" + uniq + ".csv");

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},
    downloadcsv2() {
        var self = this;
        var d = new Date();
      var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
        var header = new Array();
        self.fields.forEach(function(item) {
          //if (!item.extra) {
            header.push(item.label);
         // }
        });

        //var d = table.rows().data();
        var finalarr = new Array();
        finalarr.push(header);
        self.records.forEach(function(row) {
          var dataarr = new Array();
          self.fields.forEach(function(field) {
            

           // if (field.key != "extra") {
              var value = row[field.key];
              //dataarr.push(row[field.key]);

              if(field.key == 'Physical_Load'){              
                  value =Number(value || 0).toFixed(2);              
              }

              if(field.key == 'actual_load'){
                value = Number(value || 0).toFixed(2);
              }            
              
              
              dataarr.push(value);
            //}

          

            
          });
          finalarr.push(dataarr);
        });

        let csvContent = "data:text/csv;charset=utf-8," + finalarr.map((e) => e.join(",")).join("\n");

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "REPORT_DASHBOARD"+uniq+".csv");
        document.body.appendChild(link); // Required for FF

        link.click();
      },
      downloadPDF(){
      var self = this;

      var pdfMake = require('pdfmake/build/pdfmake.js');
      var pdfFonts = require('pdfmake/build/vfs_fonts.js');
      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      var pdfdata = new Array();
      var data = new Array();
      self.fields.forEach(element => {
        if (element.key != "actions") {
          data.push(element.label);
        }
      });
      pdfdata.push(data);
      for(var i=0; i<self.records.length; i++){
        data = new Array();

        
        self.fields.forEach(element => {
          if (element.key != "actions") {
         
            var value = self.records[i][element.key];
            if(element.key == 'current_load'){
                value = (value).toFixed(2);
              }
              
            
            if(element.key == 'total_load'){            
                value = (value/1000).toFixed(2);            
            }
            data.push(value);
            
          }
        });
        pdfdata.push(data);
      }
      var deviceid = '';
     

      var d = new Date();
      var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();
      var docDefinition = {
        content: [
          { text: 'Dashboard Report : '+deviceid, style: 'heading' },
          { text: 'From: '+self.datefrom+' 00:00:00 To: '+self.dateto+' 23:59:59', style: 'subheading' },
          {
            layout: 'lightHorizontalLines',
            table: {
              headerRows: 1,

              body: pdfdata
            }
          }
        ],
        styles: {
          heading: {
            fontSize: 20,
            alignment: 'center',
            lineHeight: 1,
            bold: true
          },
          subheading: {
            fontSize: 14,
            alignment: 'center',
            lineHeight: 2,
            bold: false
          }
        },
        defaultStyle: {
          fontSize: 10,
          bold: false
        },
        pageOrientation: 'landscape',
      };
      pdfMake.createPdf(docDefinition).download("REPORT_DASHBOARD"+uniq+".pdf");
    },
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-color: "#FFF" !important;
  background-image: none !important;
}
.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#my-table .thead-dark th {
    color: #fff;
	background-color: #FF9A37;
    border-color: #FF9A37;
}
#my-table .first-col {
   border-radius: 20px 0px 0px 0px;
   min-width: 130px;
}
#my-table .last-cal {
   border-radius: 0px 20px 0px 0px;
   min-width: 153px;
}
.borderRadius20{
	border-radius: 20px;
}
.table-responsive{
	border-radius: 20px;
}
</style>
